import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1104Component } from './kymw1104.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetSelectedCodesForCoopsService } from './api-services/get-selected-codes-for-coops.service';
import { InitItemCodeComboService } from './api-services/init-item-code-combo.service';
import { UpdateItemCodeForCoopService } from './api-services/update-item-code-for-coop.service';

/**
 * アイテム付替画面 モジュール設定クラス
 *
 * @export KYMW1104Module
 * @class KYMW1104Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule
  ],
  declarations: [
    KYMW1104Component,
  ],
  providers: [
    GetSelectedCodesForCoopsService,
    InitItemCodeComboService,
    UpdateItemCodeForCoopService
  ],

})
export class KYMW1104Module { }
